(function () {
  const SECTION_SELECTOR = '.avb-gebrauchte-maschinen';

  function fixImageSizes() {
    const sections = document.querySelectorAll(SECTION_SELECTOR);
    if (!sections.length) return;
    sections.forEach(function (section) {
      const imgs = section.querySelectorAll('.multicolumn-card__image');
      imgs.forEach(function (img) {
        const width = img.getBoundingClientRect().width;
        if (!width) return;
        const retina = Math.max(window.devicePixelRatio || 1, 2);
        const target = Math.ceil(width * retina);
        img.setAttribute('sizes', target + 'px');
        const ss = img.getAttribute('srcset');
        if (ss) { img.setAttribute('srcset', ''); img.setAttribute('srcset', ss); }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixImageSizes);
  } else {
    fixImageSizes();
  }

  let t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(fixImageSizes, 200);
  });
})();
